import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { TransactionOverviewPage } from './TransactionOverviewPage';

const searchSchema = z.object({
  month: z.string().optional(),
  expanded: z.string().optional(),
  filter: z.string().optional(),
  subFilter: z.string().optional(), // category_summarized for depth 2
});

export const Route = createFileRoute('/_protected/_consumer/transaction-overview/')({
  component: TransactionOverviewPage,
  validateSearch: searchSchema,
  beforeLoad: ({ search }) => {
    if (!search.filter) {
      throw redirect({ to: '/insights', search: { month: search.month } });
    }
  },
});
